import React from 'react';
import './TransparencySection.css';

const TransparencySection = () => {
  return (
    <section className="transparency">
      <div className="transparency__container">
        <div className="transparency__left">
          <span className="transparency__eyebrow">100% Honest pricing</span>
          <h2 className="transparency__heading">
            No hidden charges. <em>Ever.</em>
          </h2>
          <p className="transparency__body">
            Every fare is calculated transparently and shown to you BEFORE you
            confirm. No surge pricing, no last-minute add-ons, no &ldquo;convenience
            fees.&rdquo; That&rsquo;s the ZilaCab promise.
          </p>
          <a href="#pricing" className="transparency__btn">
            See our pricing &rarr;
          </a>
        </div>

        <div className="transparency__right">
          <div className="transparency__card">
            <div className="transparency__card-header">
              TaxiPool fare breakdown &mdash; example
            </div>

            <div className="transparency__row">
              <span>Base one-way fare</span>
              <span>&#8377;650</span>
            </div>

            <div className="transparency__row transparency__row--surcharge">
              <div>
                <span>No-return surcharge</span>
                <span className="transparency__row-note">
                  (No passenger found for return today)
                </span>
              </div>
              <span>+&#8377;150</span>
            </div>

            <div className="transparency__row">
              <span>Toll charges</span>
              <span>+&#8377;80</span>
            </div>

            <div className="transparency__row transparency__row--total">
              <span>Total you pay</span>
              <span>&#8377;880</span>
            </div>

            <div className="transparency__guarantee">
              &#10003; You see this BEFORE confirming &mdash; never a surprise charge
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransparencySection;
